export const IS_DEV_MODE = false;
export const API_URL = 'https://admin.qa.burnettindex.com/api';
export const SENTRY_DSN =
  'https://adf2a4a126223137164c853fb0932eaf@o4505908613218304.ingest.sentry.io/4505996115640320';
export const SENTRY_TRACES_SAMPLE_RATE = 0.5;
export const ENVIRONMENT = 'qa';
export const MUI_LICENSE_KEY =
  'b4ed3840263821e71cc15ee19155f982Tz0xMDU4NTUsRT0xNzY4MzQ4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
